/** All active trigger "main" elements */
export const G_activeTriggerElements = new Set();

/**
 * "Applied" trigger types
 */
export const G_appliedTriggerTypes = new Set([
  "class",
  "timeout",
  "active",
  "reference",
  "shift",
]);

/**
 * Options or parameters that are functions
 * @example `<easing: spring(10, 5)>`
 */
export const G_optionFunctions = new Set(["easing"]);

/**
 * References
 * @example `@grow:scale(2 <1s>)`
 */
export const G_references = new Map();

/**
 * Properties (parents) that can store multiple functional properties
 */
export const G_multiFunctionParents = new Set([
  "transform",
  "filter",
  "backdrop-filter",
]);

/**
 * Elements that has classes applied by a ClassObserver
 */
export const G_appliedClasses = new Map();

/**
 * Timeouts
 */
export const G_timeouts = new Set();

/**
 * Radios
 */
export const G_lastRadios = new Map();

/**
 * Methods that may have negative values not limited to 0-1
 */
export const G_nonLimitedMethods = new Set([
  "delta_-_continuous",
  "self_-_continuous",
  "self_-_parallax",
  "parallax",
  "continuous",
]);

/**
 * Target elements
 */
export const G_targetElements = new Set();

/**
 * Element's bounds
 * @type {Map<TorusElement, any>}
 */
export const G_bounds = new Map();